export const CLAIM_TABLE_HEADERS = [
  "Selection",
  "Action",
  "Claim Number",
  "Shipment Number",
  "PO Number",
  "Claim Type",
  "Status",
  "Related Stop",
  "Date Filed",
  "Total Claim Amount",
  "Amount Approved",
  "Amount Paid",
  "Office Code",
];

/** Display header label → API sortBy field */
export const CLAIM_SORTABLE_COLUMNS = {
  "Claim Number": "claimNumber",
  "Shipment Number": "shipmentNumber",
  "PO Number": "poNumber",
  "Claim Type": "claimType",
  "Status": "status",
  "Related Stop": "relatedStopLabel",
  "Date Filed": "dateFiled",
  "Total Claim Amount": "totalClaimAmount",
  "Amount Approved": "amountApproved",
  "Amount Paid": "amountPaid",
  "Office Code": "officeCode",
};

export const DEFAULT_CLAIM_SORT_BY = "dateFiled";
